import { Helmet } from "react-helmet-async";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { NML_ALUMNI_INTERVIEWS } from "../Config/Static/NmlAlumniInterview";
import NmlAlumniInterview from "../Components/Nml/alumni_interview";

function NmlAlumniInterviewContainer() {
  const navigate = useNavigate();
  const { pageId } = useParams();

  useEffect(() => {
    if (pageId) {
      console.log(NML_ALUMNI_INTERVIEWS);
      const isPresent = NML_ALUMNI_INTERVIEWS.find((x) => x.key === pageId);
      if (!isPresent) navigate("/404-found");
    }
  }, [pageId, navigate]);
  return (
    <>
      <Helmet>
        <title>NISSAN MOTOR CORPORATION - GLOBAL CAREER WEBSITE - JAPAN</title>
      </Helmet>
      <main className="americas-container nml-container">
        {pageId && <NmlAlumniInterview pageId={pageId} />}
      </main>
    </>
  );
}

export default NmlAlumniInterviewContainer;
